import { Modal } from 'almanac-ui/Modal'

import Styles from './LoseMembers.module.scss'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { ArrowLeft } from 'almanac-ui/icons'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { SettingsGuest, SettingsMember } from 'types'

type Member = SettingsMember | SettingsGuest

export const LoseMembers = ({
  onBack,
  onConfirm,
  members,
  isDowngradingBrandPlan,
}: {
  onBack: () => void
  onConfirm: () => void
  members: Member[]
  isDowngradingBrandPlan: boolean
}) => {
  return (
    <>
      <Modal.Header>
        <div className={Styles.header}>
          <IconButton icon={ArrowLeft} onPress={onBack} variant="tertiary" size="xs" />
          <Heading level={3}>Are you sure you want to downgrade?</Heading>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className={Styles.content}>
          <Text>Existing members will lose access to this workspace after the switch.</Text>
          <div className={Styles.membersTable}>
            <div className={Styles.header}>
              <div className={Styles.email}>
                <Text variant="label">Email</Text>
              </div>
              <div className={Styles.firstName}>
                <Text variant="label">First name</Text>
              </div>
              <div className={Styles.lastName}>
                <Text variant="label">Last name</Text>
              </div>
              <div className={Styles.role}>
                <Text variant="label">Role</Text>
              </div>
            </div>
            <div className={Styles.body}>
              {members.map((member: Member) => (
                <div key={member.id} className={Styles.memberRow}>
                  <div className={Styles.email}>
                    <Text variant="smallList">{member.email}</Text>
                  </div>
                  <div className={Styles.firstName}>
                    <Text variant="secondary">{member.first_name}</Text>
                  </div>
                  <div className={Styles.lastName}>
                    <Text variant="secondary">{member.last_name}</Text>
                  </div>
                  <div className={Styles.rolePill}>
                    <span>{member.type === 'Guest' ? 'Guest' : member.role}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="tertiary" onPress={onBack}>
            Back
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterButton onPress={onConfirm} isDisabled={isDowngradingBrandPlan}>
          Downgrade
        </Modal.FooterButton>
      </Modal.Footer>
    </>
  )
}
